import React from 'react';
import { Star, Lock } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white relative overflow-hidden" data-id="element-151">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-152"></div>

      <div className="max-w-5xl mx-auto px-4 pt-6 pb-8 md:pt-20 md:pb-24 relative z-10 flex flex-col items-center text-center" data-id="element-153">
        <div className="inline-flex items-center gap-1.5 bg-brand-cta/15 px-3 py-1 rounded-full text-[11px] md:text-sm font-semibold mb-3 md:mb-6 border border-brand-cta/30 text-brand-cta" data-id="element-154">
          <span data-id="element-155">🧠</span>
          <span data-id="element-156">Sistema N°1 para Psiquiatras de Hospital</span>
        </div>

        <h1 className="font-heading text-[26px] leading-[1.15] md:text-5xl lg:text-6xl md:leading-tight mb-4 md:mb-8 max-w-4xl" data-id="element-157">
          Matrícula Blindada desde tu Primera Guardia
        </h1>

        <div className="w-full max-w-xs md:max-w-2xl mx-auto mb-4 md:mb-10 relative" data-id="element-158">
          <div className="absolute inset-0 bg-brand-mid/30 blur-3xl rounded-full" data-id="element-159"></div>
          <img src="https://cdn.magicpatterns.com/uploads/kzZvJci5ZMqTsoR6eyv9F1/heylloyd-image-1780449518681-Photoroom.png" alt="Megapack Guardia Psiquiátrica PRO" className="w-[70%] md:w-[70%] mx-auto relative z-10 animate-float drop-shadow-2xl" loading="eager" data-id="element-160" />
        </div>

        <h2 className="text-xs md:text-2xl font-medium text-blue-100 mb-2 md:mb-3 max-w-3xl" data-id="element-161">
          6 Tomos + 6 Bonos — PDF Digital · Acceso Inmediato
        </h2>

        <p className="text-[13px] md:text-base text-gray-300 mb-5 md:mb-8 max-w-2xl leading-snug px-2" data-id="element-162">
          Protocolos, plantillas y herramientas legales para enfrentar cualquier
          crisis en guardia. Sin improvisar. Sin exponer tu matrícula.
        </p>

        <a href="#pricing" className="w-full md:w-auto bg-brand-cta hover:bg-orange-500 active:scale-[0.98] text-white font-bold text-base md:text-xl py-3.5 md:py-4 px-6 md:px-8 rounded-xl shadow-lg hover:shadow-orange-500/30 transition-all animate-pulse-slow mb-4 md:mb-6 inline-block min-h-[52px]" data-id="element-163">
          💥 QUIERO MI MEGAPACK AHORA
        </a>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 md:gap-8 text-[11px] md:text-sm text-gray-300 font-medium" data-id="element-164">
          <div className="flex items-center gap-1" data-id="element-165">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" data-id="element-166" />
            <span data-id="element-167">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-168">
            <Star className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-400 fill-yellow-400" data-id="element-169" />
            <span data-id="element-170">+800 Profesionales</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-171">
            <Star className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-400 fill-yellow-400" data-id="element-172" />
            <span data-id="element-173">4.9 Rating</span>
          </div>
        </div>
      </div>
    </section>;
}